import React, { useState } from "react";
import {
  Grid,
  Box,
  TextField,
  InputLabel,
  Divider,
  Typography,
  FormHelperText,
  MenuItem,
  Menu,
} from "@mui/material";
import { FieldArray } from "formik";
import CustomButton from "../../shared/CustomButton";
import FormikAutocomplete from "../../shared/AutoCompelete";
import PrimaryButton from "../../shared/PrimaryButton";
import LinkButton from "../../shared/LinkButton";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import DataModal from "../../shared/DynamicModal";
import FormikMultiple from "../../shared/FormikMultiple";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useFormik } from "formik";
import * as yup from "yup";
import CustomersGroupsList from "./CustomersForGroupsList";
import { useDispatch } from "react-redux";
import {
  AssginCustomersToGroup,
  GetSubscriberByGroup,
  GroupList,
} from "../state/alertActions";

const styleInput = {
  borderRadius: "4px",
  marginBottom: "15px",
  width: "408px !important",
  "& .MuiInputBase-root": {
    height: "36px",
    backgroundColor: "#fff",
    fontSize: "14px !important",
  },
  "& .MuiOutlinedInput": {
    height: "36px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #DBDEE6",
  },
};

const styleLabel = {
  color: "#050D2E",
  fontSize: ".875rem",
  fontWeight: "550",
  letterSpacing: "-0.5px",
  lineHeight: "16px",
  marginBottom: "8px",
};
const Group = ({
  menu,
  handleOpenMenu,
  Customers,
  handleCloseMenu,
  anchorEl,
  rows,
  formik,
  messageTypes,
  SendingType,
  Direction,
  touched,
  setTouched,
  NotificationTemplates,
  defaultTemplate,
  notificationType,
  CurrentGroup,
  error,
  success,
}) => {
  const [openAssginUsers, setOpenAssginUsers] = useState(false);
  const dispatch = useDispatch();
  const validationSchema = yup.object().shape({
    customers: yup.array().min(1).required().nullable(),
  });

  const CustomerFormik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: {
      customers: [],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let data = {
        id: CurrentGroup.id,
        customers: values.customers.map((element) => element.id),
      };
      dispatch(AssginCustomersToGroup(data, success, error)).then(() => {
        dispatch(
          GetSubscriberByGroup(
            {
              searchCriteria: CurrentGroup.id,
              pageNumber: 1,
              pageSize: 10,
            },
            error
          )
        );

        dispatch(GroupList(false, error));
      });

      handleCloseModal();
    },
  });

  const handelOpenModal = () => {
    setOpenAssginUsers(true);
  };

  const handleCloseModal = () => {
    setOpenAssginUsers(false);
    CustomerFormik.resetForm();
  };

  const handleDiscardChanges = () => {
    setOpenAssginUsers(false);
    setTouched(false);
  };

  const handleChange = (e) => {
    formik.handleChange(e);
    setTouched(true);
  };

  return (
    <>
      <DataModal
        onClose={handleCloseModal}
        open={openAssginUsers}
        discardChanges={handleDiscardChanges}
        HeadrTitle="Assign customer to group"
        ButtonTitle="Save"
        saveChanges={() => CustomerFormik.handleSubmit()}
      >
        <>
          <InputLabel sx={styleLabel}>Select Customers</InputLabel>
          <FormikMultiple
            options={[...Customers]}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            value={CustomerFormik.values.customers}
            name="customers"
            formik={CustomerFormik}
            label="Assign to group"
            height={"36px"}
            fullWidthFlag={true}
            validationOn={true}
            error={CustomerFormik.errors.customers}
            helperText={CustomerFormik.errors.customers}
            Info="You can assign multiple customers"
          />
        </>
      </DataModal>

      <Grid sx={{ margin: "24px 10px" }}>
        <Grid container mb={3} justifyContent="space-between">
          <Grid
            item
            sx={{
              color: "#050D2E",
              fontWeight: "550",
              fontSize: "24px",
            }}
          >
            {formik.values.name}
          </Grid>
          <Grid item>
            <CustomButton
              text="Save Changes"
              type="update"
              action={() => formik.handleSubmit()}
              disabled={!touched}
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0 0 1px 0 rgba(0,0,0,0.1), 0 0 5px 0 rgba(0,0,0,0.1)",
            height: "auto",
            position: "relative",
          }}
          p={3}
        >
          {formik.values.groupId && (
            <Grid
              sx={{
                textAlign: "end",
                position: "absolute",
                top: "10px",
                right: "20px",
              }}
            >
              <MoreHorizIcon
                sx={{ color: "#50566E" }}
                aria-controls="accordian-menu"
                aria-haspopup="true"
                onClick={menu?.length ? handleOpenMenu : null}
              />
              <Menu
                id="accordian-menu"
                keepMounted
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                {menu &&
                  menu.map((el) => {
                    return (
                      <div key={el.id} style={{ width: "200px" }}>
                        <MenuItem
                          onClick={(e) => {
                            e.stopPropagation();
                            el.handler(formik.values.groupId);
                            handleCloseMenu();
                          }}
                        >
                          {el.action}
                        </MenuItem>
                      </div>
                    );
                  })}
              </Menu>
            </Grid>
          )}

          <InputLabel sx={styleLabel}>Group Name</InputLabel>
          <TextField
            type="text"
            sx={styleInput}
            placeholder="Enter Group Name"
            name="name"
            value={formik.values.name}
            onChange={handleChange}
            helperText={formik.errors.name}
            error={formik.errors.name}
          />

          {/* <InputLabel sx={styleLabel}>
       Notification Type
    </InputLabel>
    <FormikAutocomplete 
 options={notificationType}
 isOptionEqualToValue ={ (option, value) => option === value}
 value={formik.values.notificationType}
 name="notificationType"
 formik={formik}
 width="408px"
 label="Choose Type"
 height={"36px"}
 validationOn={true}
 setTouched={setTouched}
 touched={touched}
/>
 */}
          <Box display="flex" alignItems={"baseline"} gap="15px">
            <Typography
              component="span"
              sx={{
                fontWeight: 550,
                margin: "10px 0",
              }}
            >
              Message Settings
            </Typography>
            <Divider component="div" sx={{ flex: 1 }} />
          </Box>

          <FieldArray name="MT">
            {({ insert, remove, push }) => (
              <Box>
                {formik?.values?.MT.length > 0 &&
                  formik?.values?.MT.map((friend, index) => (
                    <Box
                      sx={{
                        backgroundColor: "#afafb005",
                        padding: "20px",
                        borderRadius: "8px",
                      }}
                      mb={2}
                      key={index}
                    >
                      <Box display={"flex"} gap="15px">
                        <Grid>
                          <InputLabel sx={styleLabel}>Message Type</InputLabel>
                          <FormikAutocomplete
                            options={messageTypes}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            getOptionLabel={(option) => option.name}
                            value={formik.values.MT[index].messageNumber}
                            name={`MT.${index}.messageNumber`}
                            formik={formik}
                            label="Select"
                            height={"36px"}
                            setTouched={setTouched}
                            touched={touched}
                            width={"200px"}
                          />
                          <FormHelperText
                            sx={{
                              color: "#d32f2f",
                              marginTop: "-11px",
                              marginBottom: "15px",
                            }}
                          >
                            {Boolean(formik.errors.MT) &&
                              formik.errors?.MT[index]?.messageNumber}
                          </FormHelperText>
                        </Grid>

                        <Grid>
                          <InputLabel sx={styleLabel}>Way</InputLabel>
                          <FormikAutocomplete
                            options={Direction}
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            }
                            formik={formik}
                            value={formik.values.MT[index].direction}
                            name={`MT.${index}.direction`}
                            label="Select"
                            height={"36px"}
                            width={"200px"}
                            setTouched={setTouched}
                            touched={touched}
                          />
                          <FormHelperText
                            sx={{
                              color: "#d32f2f",
                              marginTop: "-11px",
                              marginBottom: "15px",
                            }}
                          >
                            {Boolean(formik.errors.MT) &&
                              formik.errors?.MT[index]?.direction}
                          </FormHelperText>
                        </Grid>
                      </Box>

                      <Box display={"flex"} gap="15px">
                        <Grid>
                          <InputLabel sx={styleLabel}>
                            Choose Template
                          </InputLabel>
                          <FormikAutocomplete
                            options={NotificationTemplates}
                            getOptionLabel={(option) =>
                              option.name ? option.name : ""
                            }
                            value={formik.values.MT[index].notificationTemplate}
                            name={`MT.${index}.notificationTemplate`}
                            formik={formik}
                            label="Select"
                            height={"36px"}
                            width={"200px"}
                            setTouched={setTouched}
                            touched={touched}
                          />
                        </Grid>

                        <Grid>
                          <InputLabel sx={styleLabel}>Sending Type</InputLabel>
                          <FormikAutocomplete
                            options={SendingType}
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            }
                            value={formik.values.MT[index].sendingType}
                            name={`MT.${index}.sendingType`}
                            formik={formik}
                            label="Select"
                            height={"36px"}
                            width={"200px"}
                            setTouched={setTouched}
                            touched={touched}
                          />
                          <FormHelperText
                            sx={{
                              color: "#d32f2f",
                              marginTop: "-11px",
                              marginBottom: "15px",
                            }}
                          >
                            {Boolean(formik.errors.MT) &&
                              formik.errors?.MT[index]?.sendingType}
                          </FormHelperText>
                        </Grid>
                      </Box>
                      <PrimaryButton
                        onClick={() => remove(index)}
                        disabled={formik?.values?.MT.length === 1}
                      >
                        Remove
                      </PrimaryButton>
                    </Box>
                  ))}
                <LinkButton
                  sx={{ marginBottom: "10px", fontSize: "14px" }}
                  color="#007AFF"
                  onClick={() =>
                    push({
                      messageNumber: null,
                      sendingType: SendingType[2],
                      way: "",
                      notificationTemplate: defaultTemplate || "",
                    })
                  }
                >
                  + Add new MT
                </LinkButton>
              </Box>
            )}
          </FieldArray>

          <Box display="flex" alignItems={"baseline"} gap="15px">
            <Typography
              component="span"
              sx={{
                fontWeight: 550,
                margin: "10px 0",
              }}
            >
              Group Customers
            </Typography>
            <Divider component="div" sx={{ flex: 1 }} />
          </Box>

          <Box textAlign={"end"}>
            {rows?.length > 0 ? (
              <>
                <CustomButton
                  text="Assign Customers"
                  processing={false}
                  type="dark"
                  icon={<GroupAddIcon />}
                  action={() => handelOpenModal()}
                />
                <CustomersGroupsList
                  data={CurrentGroup.id}
                  error={error}
                  success={success}
                />
              </>
            ) : (
              <>
                {CurrentGroup.id && (
                  <Box
                    sx={{
                      border: "1px solid #E7E9EF",
                      borderRadius: "4px",
                      height: "400px",
                      margin: "20px 0",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Grid sx={{ textAlign: "center" }}>
                      <Typography
                        sx={{
                          fontWeight: "550",
                          color: "#050D2E",
                          margin: "10px 0",
                        }}
                      >
                        No customers assigned to this group yet!
                      </Typography>
                      <CustomButton
                        text="Assign Customers"
                        processing={false}
                        type="dark"
                        icon={<GroupAddIcon />}
                        action={() => handelOpenModal()}
                      />
                    </Grid>
                  </Box>
                )}
              </>
            )}
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default Group;
